import { Fragment, memo } from 'react';
import { SignatoriesVM } from 'civil-status/view-models/step-form';
import { Grid } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiButton } from 'shell/components/shared/button';
import { Check } from '@mui/icons-material';

interface FormDigitalSignatureProps {
  item?: SignatoriesVM;
  onChange: (
    itemChange: SignatoriesVM,
    key: keyof SignatoriesVM,
    value: SignatoriesVM[keyof SignatoriesVM]
  ) => void;
  onClickVerify: (item?: SignatoriesVM) => void;
  onClickCancel: (item: SignatoriesVM) => void;
  onClickSend: (item: SignatoriesVM) => void;
}

const FormDigitalSignatureComponent = ({
  item = {},
  onChange,
  onClickVerify,
  onClickCancel,
  onClickSend,
}: FormDigitalSignatureProps): React.ReactElement => {
  return (
    <Fragment>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Email"
          label="Email *"
          id="email"
          name="email"
          fullWidth
          type="text"
          variant="outlined"
          value={item?.email || ''}
          disabled={item.isSend}
          onChange={(event) => onChange(item, 'email', event.target.value)}
        />
      </Grid>
      {item.isSend || item.isVerify ? (
        item.isVerify ? (
          <Grid item xs={12} md={2} style={{ color: 'green' }}>
            <Check color="success" /> Firma verificata
          </Grid>
        ) : (
          <Fragment>
            <Grid item xs={12} md={2} display="flex" alignItems="center" justifyContent="center">
              <PmiButton
                color="cdmBrandThird"
                variant="outlined"
                onClick={() => onClickVerify(item)}
              >
                Verifica
              </PmiButton>
            </Grid>
            <Grid item xs={12} md={2} display="flex" alignItems="center" justifyContent="center">
              <PmiButton
                color="cdmBrandThird"
                variant="outlined"
                onClick={() => onClickCancel(item)}
              >
                Annulla
              </PmiButton>
            </Grid>
          </Fragment>
        )
      ) : (
        <Grid item xs={12} md={2} display="flex" alignItems="center" justifyContent="center">
          <PmiButton
            color="cdmBrandThird"
            variant="outlined"
            onClick={() => onClickSend(item)}
            disabled={!Boolean(item.email)}
          >
            Invia
          </PmiButton>
        </Grid>
      )}
    </Fragment>
  );
};

FormDigitalSignatureComponent.displayName = 'Form digital signature component';

const FormDigitalSignature = memo(FormDigitalSignatureComponent);

export default FormDigitalSignature;
